import React from 'react';
import './Features.css';

const Features = () => {
    return (
            <section class="features-bg py-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-6 mb-4 mb-md-0">
        <img alt="" class="img-fluid" src="https://cdn.shopify.com/s/files/1/0417/7710/3008/files/image_features_42ebc162-66b0-4250-b89c-7ad02f6c937e_600x.png?v=1593673698"/>
      </div>
      <div class="col-12 col-md-6 col-lg-5 ml-md-auto text-left">
        <h1>LUKMALL MEN</h1>
        <p class="">Lukmall Men Breathable Mesh Casual Lightweight Slip-on Summer Sneakers running sneakers jogging workout athletic footwear outdoor sport shoe</p>
        <a class="features-btn" href="https://www.froala.com">BUY NOW</a>
      </div>
    </div>
  </div>
</section>
    );
};

export default Features;